export default __webpack_public_path__ + "static/media/hamburger-menu.289e7f2d.svg";